import React from 'react';

import { T8y } from 'ui';

import { ReactComponent as AmericanExpress } from 'assets/images/icons/paymentOptions/AmericanExpress_sm.svg';
import { ReactComponent as ApplePay } from 'assets/images/icons/paymentOptions/apple-pay.svg';
import { ReactComponent as GooglePay } from 'assets/images/icons/paymentOptions/GooglePay.svg';
import { ReactComponent as Mastercard } from 'assets/images/icons/paymentOptions/Mastercard_sm.svg';
import { ReactComponent as Visa } from 'assets/images/icons/paymentOptions/Visa_sm.svg';

import style from './details.module.scss';

export const Details = ({ details, dimensions }) => {
  return (
    <div className={style.container}>
      <div className={style.detailsItem}>
        <T8y variant="t2" mb className={style.title} bold>
          Product Dimensions
        </T8y>
        <T8y variant="t2v1" color="midGray">
          {dimensions}
        </T8y>
      </div>
      <div className={style.detailsItem}>
        <T8y variant="t2" mb className={style.title} bold>
          Product Details
        </T8y>
        <ul className={style.productDetails}>
          {details.map((el, i) => (
            <li key={i}>{el}</li>
          ))}
        </ul>
      </div>
      <div className={style.detailsItem}>
        <T8y variant="t2" className={style.title} bold>
          Payment options
        </T8y>
        <div className={style.payWithCreditCard}>
          <Mastercard />
          <Visa />
          <AmericanExpress />
          <ApplePay />
          <GooglePay />
        </div>
      </div>
    </div>
  );
};
